import { bunja } from 'bunja';
import { atomWithDefault } from 'jotai/utils';

import { abTestBunja } from '@flipster/features/src/shared/ab-test';

export const pendingPositionTableBunja = bunja(() => {
  const { getAbFlagAtom } = bunja.use(abTestBunja);
  const isLimitOrderEnabledAtom = getAbFlagAtom('25q4-spot-limit-order', 'on');
  const pendingPositionTypeAtom = atomWithDefault<'limit' | 'trigger'>((get) =>
    get(isLimitOrderEnabledAtom) ? 'limit' : 'trigger',
  );

  return { pendingPositionTypeAtom };
});
pendingPositionTableBunja.debugLabel = 'pendingPositionTableBunja';
